var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.917,
    height: 66.502,
    viewBox: "0 0 54.917 66.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2597",
    "data-name": "Rectangle 2597",
    width: 54.917,
    height: 66.502,
    fill: "#f7edd6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1991",
    "data-name": "Group 1991",
    opacity: 0.526
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1990",
    "data-name": "Group 1990",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6443",
    "data-name": "Path 6443",
    d: "M54.917,16.3a2,2,0,0,0-.484-1.18L40.7.535A1.718,1.718,0,0,0,38.278.469,1.767,1.767,0,0,0,38.21,2.9L49.231,14.587H1.716a1.716,1.716,0,0,0,0,3.433H49.231L38.21,29.711a1.8,1.8,0,0,0,.067,2.427,1.717,1.717,0,0,0,2.426-.067L54.433,17.483a1.525,1.525,0,0,0,.484-1.179",
    transform: "translate(0 0.001)",
    fill: "#f7edd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6444",
    "data-name": "Path 6444",
    d: "M0,46.625a2,2,0,0,1,.484-1.18L14.214,30.856a1.718,1.718,0,0,1,2.426-.066,1.767,1.767,0,0,1,.067,2.427L5.685,44.908H53.2a1.716,1.716,0,0,1,0,3.433H5.685L16.706,60.032a1.8,1.8,0,0,1-.067,2.427,1.717,1.717,0,0,1-2.426-.067L.484,47.8A1.525,1.525,0,0,1,0,46.625",
    transform: "translate(0 3.574)",
    fill: "#f7edd6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransition);
export default __webpack_public_path__ + "static/media/Transition.3da5a74e9e4c57421a5112fddd610d54.svg";
export { ForwardRef as ReactComponent };